import React from 'react'
import style from "./contact.module.css"

const Contact = () => {
  return (
    <div>
        <div className={style.con1} id="contact" >
            <h1>
                Contact
            </h1>
        </div>
        <div className={style.con2}>
            <div>
                <div className={style.conflex}>
                    <i className="fa-solid fa-envelope"></i>
                    <a href="mailto:prakprasar@gmail.com" target="_blank">Gmail</a>
                </div>
                <div className={style.conflex}>
                    <i className="fa-solid fa-message"></i>
                    <a href=" https://wa.me/919900705885" target="_blank">Chat</a>
                </div>
                <div className={style.conflex}>
                    <i className="fa-brands fa-github"></i>
                    <a href="https://github.com/Prakarshprasar" target="_blank">GitHub</a>
                </div>
                <div className={style.conflex}>
                    <i className="fa-brands fa-linkedin"></i>
                    <a href="https://www.linkedin.com/in/prakarsh-prasar-66ab02229/" target="_blank">LinkedIn</a>
                </div>
                <div className={style.conflex}>
                    <i className="fa-brands fa-hackerrank"></i>
                    <a href="https://www.hackerrank.com/prakprasar" target="_blank">HackerRank</a>
                </div>
            </div>
            <img src="https://www.ravishukla.me/static/media/about.aee0f771fbfc1e7b8fa8.png" alt="" />
        </div>
        <div className={style.end}>
            <p>prakprasar@gmail.com</p>
            <p>Mobile No : +91 9900705885</p>
        </div>
        
        
    </div>
  )
}

export default Contact